var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoading1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 67,
    viewBox: "0 0 66 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3499_8862)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint0_angular_3499_8862_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -0.0325 0.0325 0 33 33.8262)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -1020,
    y: -1020,
    width: 2040,
    height: 2040
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg,rgba(108, 227, 196, 1) 0deg,rgba(255, 255, 255, 1) 360deg)",
      height: "100%",
      width: "100%",
      opacity: 1
    }
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 33.8262C0.5 15.8769 15.0507 1.32617 33 1.32617C50.9493 1.32617 65.5 15.8769 65.5 33.8262C65.5 51.7754 50.9493 66.3262 33 66.3262C15.0507 66.3262 0.5 51.7754 0.5 33.8262ZM60.625 33.8262C60.625 18.5693 48.2569 6.20117 33 6.20117C17.7431 6.20117 5.375 18.5693 5.375 33.8262C5.375 49.083 17.7431 61.4512 33 61.4512C48.2569 61.4512 60.625 49.083 60.625 33.8262Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":0.42352941632270813,\"g\":0.89019608497619629,\"b\":0.76862746477127075,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":1.0},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":0.42352941632270813,\"g\":0.89019608497619629,\"b\":0.76862746477127075,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":1.0},\"position\":1.0}],\"transform\":{\"m00\":-4.4875089802692402e-15,\"m01\":65.0,\"m02\":0.50,\"m10\":-65.0,\"m11\":-4.4875089802692402e-15,\"m12\":66.3261718750},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "paint0_angular_3499_8862_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 33.8262C0.5 15.8769 15.0507 1.32617 33 1.32617C50.9493 1.32617 65.5 15.8769 65.5 33.8262C65.5 51.7754 50.9493 66.3262 33 66.3262C15.0507 66.3262 0.5 51.7754 0.5 33.8262ZM60.625 33.8262C60.625 18.5693 48.2569 6.20117 33 6.20117C17.7431 6.20117 5.375 18.5693 5.375 33.8262C5.375 49.083 17.7431 61.4512 33 61.4512C48.2569 61.4512 60.625 49.083 60.625 33.8262Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3499_8862"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65.65,
    fill: "white",
    transform: "translate(0.5 0.675781)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading1);
export default __webpack_public_path__ + "static/media/Loading1.3f028fcb343d0856a1ec5da603dbb622.svg";
export { ForwardRef as ReactComponent };